import styles from 'css/src/components/share-video/VideoVisibilitySelect.module.scss';

import React from 'react';

import { VideoVisibility } from 'js/src/client';
import ImageSelect from 'js/src/components/common/ui/ImageSelect/ImageSelect';

const OPTIONS = [
    {
        label: 'Anyone with a link can view',
        value: VideoVisibility.UNLISTED,
        picture_url: 'https://cdn.lumen5.com/lumen5-site-images/video_visibility_icons/link.svg',
    },
    {
        label: 'This video is private',
        value: VideoVisibility.PRIVATE,
        picture_url: 'https://cdn.lumen5.com/lumen5-site-images/video_visibility_icons/lock.svg',
    },
];
const VALUES = {
    [VideoVisibility.PRIVATE]: {
        label: 'This video is private',
        value: VideoVisibility.PRIVATE,
        picture_url: 'https://cdn.lumen5.com/lumen5-site-images/video_visibility_icons/lock.svg',
    },
    [VideoVisibility.UNLISTED]: {
        label: 'Anyone with a link can view',
        value: VideoVisibility.UNLISTED,
        picture_url: 'https://cdn.lumen5.com/lumen5-site-images/video_visibility_icons/link.svg',
    },
};

const VideoVisibilitySelect = React.memo(function VideoVisibilitySelect({
    visibility,
    updateVideoVisibility,
}: {
    visibility: VideoVisibility;
    updateVideoVisibility: (visibility: VideoVisibility) => void;
}) {
    const visibilityDropdownClicked = React.useCallback(() => {
        analytics.track('Video visibility dropdown clicked');
    }, []);
    const onChange = React.useCallback(
        (value: VideoVisibility) => {
            updateVideoVisibility(value);
        },
        [updateVideoVisibility],
    );

    return (
        <div className={styles['video-visibility-select']} translate="no">
            <ImageSelect<VideoVisibility>
                isMulti={false}
                className="visibility-select"
                onChange={onChange}
                options={OPTIONS}
                isSearchable={false}
                value={VALUES[visibility]}
                onFocus={visibilityDropdownClicked}
            />
        </div>
    );
});

export default VideoVisibilitySelect;
